import React from "react";

export function AffiliateDisclosure({ compact }) {
  if (compact) {
    return (
      <p data-testid="affiliate-disclosure-compact" className="font-mono-pm text-[11px] text-stone-500 leading-relaxed border border-stone-300 bg-white p-3">
        The PM Test may earn a commission when you purchase or sign up through certain links, at no additional cost to you. Affiliate relationships do not influence our scores or recommendations.
      </p>
    );
  }
  return (
    <div data-testid="affiliate-disclosure" className="border-l-4 border-stone-900 bg-white p-4">
      <p className="font-mono-pm text-xs text-stone-600 leading-relaxed">
        <span className="font-bold text-stone-900 uppercase tracking-wider">Disclosure — </span>
        The PM Test may earn a commission when you purchase or sign up through certain links, at no additional cost to you. Affiliate relationships do not influence our scores or recommendations.
      </p>
    </div>
  );
}
